<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="idonia-viewer" @click="activeIndex = -1">
    <!-- Dicom Visor -->
    <div class="container" v-if="seriesID">
      <ViewerContainer
        :images="images"
        :back="goBack"
        key="image"
        v-if="seriesID"
        :loading.sync="loading"
        :studyID="studyID"
        :seriesID="seriesID"
        :listItems="listItems"
        :loadImagesOnDemand="loadImagesOnDemand"
      ></ViewerContainer>
    </div>

    <div v-else>
      <v-toolbar class="elevation-0" dark>
        <v-btn icon v-if="$machine.isDesktop" @click="goBack">
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <div :class="$vuetify.breakpoint.smAndUp ? 'toolbar_inline' : ''">
          <v-toolbar-title v-if="toolbarData" class="pl-2">{{ toolbarData }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </div>
      </v-toolbar>

      <!-- Patient and Studies -->
      <v-container
        fluid
        grid-list-md
        class="pa-2"
        style="user-select: none;"
        v-if="thereAreVisualContent"
      >
        <v-layout wrap justify-space-around class="viewer-layout">
          <v-flex
            :style="studyID ? 'width:250px;' : ''"
            :xs12="!studyID"
            :md6="!studyID"
            :lg4="!studyID"
            v-for="(item, index) in listItems"
            :key="item.studyID"
          >
            <touch-wrapper
              @click="setActive(index)"
              @dblclick="goToViewer(index, item.destination)"
              @tap="$router.push(item.destination)"
            >
              <v-card class="pa-1" height="88px" :class="{ selected: index === activeIndex }" dark>
                <v-layout>
                  <v-flex shrink class="viewer-card-media">
                    <Thumbnail :avatar="item.avatar" :icon="item.icon"></Thumbnail>
                  </v-flex>
                  <v-flex grow class="viewer-card-content pr-3 pl-3">
                    <v-card-title
                      class="pa-0 ma-0"
                      :class="!studyID ? 'subheading' : ''"
                    >
                      <v-flex grow row-reverse class="text-sm-left layout-ellipsis">
                        {{ item.name }}
                      </v-flex>
                    </v-card-title>
                    <v-divider class="mb-2"></v-divider>
                    <v-card-actions class="pa-0 layout-ellipsis">
                      <v-flex grow row-reverse class="text-sm-right">
                        <template v-for="(info, index) in item.processedData()">
                          <v-tooltip bottom :key="index">
                            <template v-slot:activator="{ on }">
                              <span
                                v-if="info.value"
                                slot="activator"
                                :class="
                                  index !== item.data.length - 1 ? 'mr-2' : ''
                                "
                                v-on="on"
                              >
                                <span class="key">
                                  <v-icon
                                    :dark="!!studyID"
                                    style="transition: none !important;"
                                  >{{ info.icon }}</v-icon>
                                </span>
                                <span>{{ info.value }}</span>
                              </span>
                            </template>
                            <span>{{ $t(info.name) }}</span>
                          </v-tooltip>
                        </template>
                      </v-flex>
                    </v-card-actions>
                  </v-flex>
                </v-layout>
              </v-card>
            </touch-wrapper>
          </v-flex>
          <v-flex v-for="(item, index) in 10" :key="index" style="width:250px;">
            <div></div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container v-else>
        <h3 class="warning-text">{{ $t('no_files_level_' + (studyID ? 'study' : 'other')) }}</h3>
      </v-container>
    </div>
  </div>
</template>

<script>
import ViewerContainer from '@/components/ViewerContainer.vue'
import TouchWrapper from '@/components/common/TouchWrapper.vue'
import { TAG_DICTIONARY } from '@/commons/dataDictionary'
import { dicomweb, VIEWER_TYPES } from '@/commons/constants'
import config from '@/commons/config'
import constants from '@/commons/constants'
import { EventBus } from '@/components/Viewer.vue'
import Thumbnail from '@/components/Thumbnail.vue'

const moment = require('moment')

export default {
  name: 'idonia-viewer',
  components: { TouchWrapper, ViewerContainer, Thumbnail },
  props: {
    token: {
      type: String,
      default: ''
    },
    accountId: {
      type: Number,
      default: 0
    },
    file: {
      type: Object,
      default: null
    },
    rootNavPath: {
      type: Array,
      required: true
    },
    rootNavCurrent: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      name: '',
      patients: {},
      images: [],
      activeIndex: -1,
      thereAreVisualContent: false,
      loading: false,
      viewerOptions: {
        inline: true,
        button: true,
        navbar: true,
        title: false,
        toolbar: true,
        tooltip: false,
        movable: true,
        zoomable: true,
        rotatable: true,
        scalable: true,
        transition: false,
        fullscreen: true,
        keyboard: true,
        loading: true,
        url: 'data-source'
      },
      dicomVault: {},
      study: {},
      type: VIEWER_TYPES.WADO
    }
  },
  computed: {
    destinationURL () {
      if (this.$route.params.sha) {
        return `/v/${this.$route.params.namespace}/${this.$route.params.sha}/${this.fileID}/wado`
      } else if (this.fileID) {
        return `/file/${this.fileID}/wado`
      }

      return '/wado'
    },
    fileID () {
      return this.$route.params.id
    },
    studyID () {
      return this.$route.params.study
    },
    seriesID () {
      return this.$route.params.series
    },
    toolbarData () {
      let retData = ''
      if (this.studyID) {
        retData = this.study['StudyDescription'] && this.study['StudyDescription'].value
      }
      return retData
    },
    listItems () {
      if (this.studyID && this.isAlreadyLoadWADO()) {
        return this.study.series
      }
      return {}
    }
  },
  watch: {
    $route () {
      this.thereAreVisualContent = this.isAlreadyLoadWADO()
    },
    seriesID () {
      this.loadImages()
    }
  },
  async mounted () {
    // Get dicom_vault to get wado values
    const { dicom_vault } = this.file

    // Set dicom_vault to component state
    this.dicomVault = dicom_vault

    function handlerConfiguration (xhr) {
      xhr.setRequestHeader('Authorization', 'Bearer ' + this.dicomVault.auth_token)
      xhr.onerror = e => {
        if (e.currentTarget.status === 0) {
          // Emit authorization error to manage in each component
          EventBus.$emit('onAuthorizationError', {})
        }
      }
    }

    // Configure CORS error
    const configuration = {
      beforeSend: handlerConfiguration.bind(this)
    }
    config.cornerstoneWebImageLoader.configure(configuration)
    config.cornerstoneWADOImageLoader.configure(configuration)

    await this.getWADO()
  },
  methods: {
    goBack () {
      if (
        this.destinationURL &&
        this.studyID &&
        this.seriesID
      ) {
        this.$router.push({
          path: `${this.destinationURL}/study/${this.studyID}`,
          query: { ...this.$route.query },
          hash: this.$route.hash
        })
        return
      }
      if (
        this.destinationURL &&
        this.studyID
      ) {
        this.$router.push({
          path: `${this.destinationURL}`,
          query: { ...this.$route.query },
          hash: this.$route.hash
        })
        return
      }
      this.$emit('back')
    },
    refreshAppbar () {
      let path = []
      if (this.rootNavPath) {
        path = this.rootNavPath.slice(0)
      }
      path = path.filter(x => x.id)
      let lastElem = this.rootNavCurrent
      if (!lastElem.id) {
        lastElem = path.pop()
      }

      var actualElem = null

      if (this.fileID) {
        lastElem.link = this.destinationURL + '/' + this.fileID + '/wado/'
      }

      if (this.studyID && actualElem) {
        actualElem = actualElem.studies[this.studyID]
        if (actualElem) {
          path.push(lastElem)
          lastElem = {
            id: actualElem.id,
            name: actualElem.name,
            link: actualElem.destination,
            icon: actualElem.icon
          }
        }
      }

      if (this.seriesID && actualElem) {
        actualElem = actualElem.series[this.seriesID]
        if (actualElem) {
          path.push(lastElem)
          lastElem = {
            id: actualElem.id,
            name: actualElem.name,
            link: actualElem.destination,
            icon: actualElem.icon
          }
        }
      }

      this.$emit('navPath', path)
      if (actualElem || (this.containerID && !this.patientID)) {
        this.$emit('navCurrent', lastElem)
      }
    },
    setActive (index) {
      this.activeIndex = index
    },
    async loadImages () {
      console.log('Loading images', this.studyID, this.seriesID)

      if (this.seriesID) {
        this.images = []
        if (
          !this.study.series[this.seriesID].instances.length &&
          this.study.series[this.seriesID].sopInstanceUIDs.length
        ) {
          console.log('images not found, retrieving')
          this.study.series[this.seriesID].instances = await this.getInstancesBySerieIndex(this.seriesID)
          this.images.push(this.study.series[this.seriesID].instances)
        } else {
          this.images.push(this.study.series[this.seriesID].instances)
        }
      }
    },
    async loadImagesOnDemand (serieIndex) {
      console.log('loadImagesOnDemand', this.studyID, serieIndex)

      this.study.series[serieIndex].instances = await this.getInstancesBySerieIndex(serieIndex)
      return this.study.series[serieIndex].instances
    },
    getInstancesBySerieIndex (serieIndex) {
      console.log('Loading images', this.studyID, serieIndex)
      return this.map(this.study.series[serieIndex]
          .sopInstanceUIDs, async sopInstanceUID => {
        const dicomInstance = await dicomweb
            .get(this.dicomVault)
            .retrieveInstanceMetadata({
              studyInstanceUID: this.studyID,
              seriesInstanceUID: this.study.series[serieIndex].id,
              sopInstanceUID
            })

        for (const instance of dicomInstance) {
          let keys = this.getKeys(instance)

          let instanceElement = {}
          instanceElement.dicom_tags = []
          for (const k of keys) {
            const element = this.getElement(instance[k], k)
            if (element) instanceElement.dicom_tags.push(element)
          }

          instanceElement.instance_type = constants.dicom
          instanceElement.urls = {}
          instanceElement.urls.dicom = `${this.dicomVault.url}/studies/${this.studyID}/series/${serieIndex}/instances/${sopInstanceUID}`
          instanceElement.urls.hd = `${this.dicomVault.url}/studies/${this.studyID}/series/${serieIndex}/instances/${sopInstanceUID}/rendered`

          return instanceElement
        }
      })
    },
    goToViewer (index, destination) {
      this.setActive(index)
      this.$router.push(destination)
    },
    isAlreadyLoadWADO () {
      return (
        this.study && this.study.series && Object.keys(this.study.series).length
      )
    },
    getTag (tag) {
      const group = tag.substring(0, 4)
      const element = tag.substring(4, 9)
      const tagIndex = ('(' + group + ',' + element + ')').toUpperCase()
      const tagValue = TAG_DICTIONARY[tagIndex]
      if (!tagValue) {
        return
      }
      tagValue['tag_group'] = group && group.replace(/^0+/, '')
      tagValue['tag_element'] = element && element.replace(/^0+/, '')
      return tagValue
    },
    getKeys (data) {
      let keys = []
      for (var propertyName in data) {
        keys.push(propertyName)
      }
      return keys.sort()
    },
    getElement (item, key) {
      const tag = this.getTag(key)
      if (tag) {
        const element = { ...item, ...tag }
        if (element && element.Value) {
          element['value'] =
            element.Value.length > 1
              ? element.Value.join('\\')
              : element.Value[0]
          delete element.Value
        }
        return element
      }
      return null
    },
    handlerStudyElement (studyInstanceUID, study, studyElementBase) {
      const studyElement = {
        ...studyElementBase,
        icon: 'folder',
        data: [
          {
            icon: 'local_hospital',
            name: 'Institution',
            value:
              studyElementBase.InstitutionName &&
              studyElementBase.InstitutionName.value
          },
          {
            icon: 'accessibility',
            name: 'Body Part',
            value:
              studyElementBase.BodyPartExamined &&
              studyElementBase.BodyPartExamined.value
          },
          {
            icon: 'calendar_today',
            name: 'Date of Study',
            value: moment(study.StudyDate).format('YYYY-MM-DD')
          }
        ],
        destination: `${this.destinationURL}/wado/study/${studyInstanceUID}`,
        processedData () {
          var filtered = this.data.filter(function (el) {
            return !!el.value
          })
          console.log(filtered)
          return filtered.slice(-2)
        }
      }

      return studyElement
    },
    handlerSerieElement (studyInstanceUID, seriesInstanceUID, serieElementBase) {
      const serieElement = {
        id: seriesInstanceUID,
        ...serieElementBase,
        name: serieElementBase.SeriesDescription.value,
        avatar: null,
        icon: 'burst_mode',
        data: [
          {
            icon: 'input',
            name: 'Modalities',
            value: serieElementBase.Modality && serieElementBase.Modality.value
          },
          {
            icon: 'burst_mode',
            name: 'Images',
            value: null
          }
        ],
        destination: `${this.destinationURL}/wado/study/${studyInstanceUID}/series/${seriesInstanceUID}`,
        processedData () {
          var filtered = this.data.filter(function (el) {
            return el.value != null
          })
          return filtered.slice(-2)
        },
        sopInstanceUIDs: [],
        instances: []
      }

      return serieElement
    },
    async getWADO () {
      const studyInstanceUID = this.dicomVault.study_uid

      let studies
      try {
        studies = await dicomweb.get(this.dicomVault).searchForStudies({
          queryParams: {
            studyInstanceUID,
            includefield: '00080080,00180015,00081030'
          }
        })

        console.log(studies)
        const study = studies[0]

        let keys = this.getKeys(study)

        let studyElement = {}
        for (const k of keys) {
          const element = this.getElement(study[k], k)
          studyElement[element.name] = element
        }

        this.study = this.handlerStudyElement(
          studyInstanceUID,
          study,
          studyElement
        )

        // Set reactive series property
        this.$set(this.study, 'series', {})

        let series
        try {
          series = await dicomweb.get(this.dicomVault).searchForSeries({
            studyInstanceUID
          })

          console.log(series)

          for (const serie of series) {
            let keys = this.getKeys(serie)

            let serieElement = {}
            let seriesInstanceUID
            for (const k of keys) {
              const element = this.getElement(serie[k], k)
              if (element.name === 'SeriesInstanceUID') {
                seriesInstanceUID = element.value
              }
              serieElement[element.name] = element
            }

            this.study.series[seriesInstanceUID] = this.handlerSerieElement(
              studyInstanceUID,
              seriesInstanceUID,
              serieElement
            )
            // Load sync instances
            this.loadSeriesInstances(studyInstanceUID, seriesInstanceUID)
          }

          this.thereAreVisualContent = this.isAlreadyLoadWADO()

          if (Object.keys(this.study.series).length === 1) {
            let series = this.study.series[Object.keys(this.study.series)[0]]
            console.log("GOING 1: series.destination")
            this.$router.push(series.destination)
          } else {
            console.log("GOING 2: this.study.destination")
            this.$router.push(this.study.destination)
          }
        } catch (error) {
          console.log(error)
        }
      } catch (error) {
        console.log(error)
      }
    },
    loadSeriesInstances (studyInstanceUID, seriesInstanceUID) {
      const serieElement = { ...this.study.series[seriesInstanceUID] }
      dicomweb
        .get(this.dicomVault)
        .searchForInstances({
          studyInstanceUID,
          seriesInstanceUID
        })
        .then(async instances => {
          console.log(instances)

          let sopInstanceUIDs = []
          let sopInstanceUID
          const sopInstanceUIDTag = '00080018'

          for (const instance of instances) {
            const element = this.getElement(
              instance[sopInstanceUIDTag],
              sopInstanceUIDTag
            )
            if (element.name === 'SOPInstanceUID') {
              sopInstanceUID = element.value
            }
            sopInstanceUIDs.push(sopInstanceUID)
          }

          let thumbnailUrl = null
          try {
            const response = await fetch(
              this.dicomVault.url
                .concat('/studies/')
                .concat(studyInstanceUID)
                .concat('/series/')
                .concat(seriesInstanceUID)
                .concat('/thumbnail')
            )
            if (response.status === 200) {
              thumbnailUrl = URL.createObjectURL(thumbnailUrl.blob())
            }
          } catch (error) {
            console.log(error)
          }
          serieElement.avatar = thumbnailUrl
          serieElement.data[1].value = sopInstanceUIDs.length
          serieElement.sopInstanceUIDs = sopInstanceUIDs
          this.study.series[seriesInstanceUID] = serieElement
          this.study.series = Object.assign({}, this.study.series)
        })
    },
    async map (array, callback, thisArg) {
      const promiseArray = []
      for (let i = 0; i < array.length; i++) {
        if (i in array) {
          promiseArray[i] = Promise.resolve(array[i]).then((currentValue) => {
            return callback.call(thisArg || this, currentValue, i, array)
          })
        }
      }
      return Promise.all(promiseArray)
    }
  }
}
</script>

<style lang="scss">
@import url("~viewerjs/dist/viewer.css");

.idonia-viewer {
  .viewer-container {
    min-height: 590px !important;
    width: 100%;
    @media screen and (max-height: 599px) {
      min-height: auto !important;
    }
  }
}
</style>

<style lang="scss" scoped>
::v-deep p {
  white-space: normal;
  line-height: 16px;
  margin-top: 3px;
}

::v-deep span {
  white-space: nowrap;
  display: inline-block;
}

::v-deep span:not(.key) {
  @media screen and (min-width: 599px) {
    margin: auto;
  }
  vertical-align: bottom;
}

::v-deep .key {
  margin-right: 4px;
  font-weight: 500;
}

.viewer-layout {
  flex-basis: 100% !important;
  margin-top: 2px !important;
  width: 100% !important; // iOS bug
}

.viewer-card-content {
  flex: 1;
  min-width: 0;
}

.viewer-card-media {
  width: 80px;
}

.layout-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.toolbar {
  background-color: #404040 !important;
}

.v-card.selected {
  background-color: #868686;
}

.container {
  display: flex;
  justify-content: center;
  margin: 0;
  padding: 0;
  height: 100%;
  max-width: 100% !important;
}

.idonia-viewer,
#idonia-viewer {
  margin: 0;
  padding: 0;
  height: 100vh;
  width: 100%;
  max-width: 100%;
  background-color: #303030;
  overflow-y: auto;
}

.flex {
  margin-bottom: 4px;
  align-items: center;
  justify-content: center;
  @media screen and (min-width: 599px) {
    text-align: center;
  }
}

.flex-empty {
  height: 0px !important;
}

.toolbar_inline {
  display: flex;
  width: 100%;
}

.warning-text {
  position: absolute;
  text-align: center;
  color: white;
  top: 50%;
}
</style>
